import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';

import { SaldoIndemnizacionesComponent } from './SaldoIndemnizaciones.component';


import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';





const routes = [
    {
        path     : 'SaldoIndemnizaciones',
        component: SaldoIndemnizacionesComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'SaldoIndemnizaciones',
          nombreFormulario : 'SaldoIndemnizaciones'
        } 
    }
];

@NgModule({
    declarations: [
        SaldoIndemnizacionesComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        SaldoIndemnizacionesComponent
    ]
})

export class SaldoIndemnizacionesModule
{
}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Saldo Indemnizaciones/SaldoIndemnizaciones.module.ts